import React from 'react';

const StatusText = ({ itemStatus, width = '100%' }) => {
    let textClass = '';
    switch (itemStatus) {
        case 'Draft':
        case 'Concept':
        case 'Paused':
        case 'Sold':
        case 'Not Available':
        case 'Expired':
            textClass = 'status-text-secondary';
            break;
        case 'Closed':
            textClass = 'status-text-black';
            break;
        case 'Estimated':
        case 'Invoiced':
        case 'Sourced':
        case 'Inspected':
        case 'Ready for Testing':
        case 'Ready for Inbounding':
        case 'Ready for Packing':
        case 'Ready To Ship':
        case 'Ready for Repair':
        case 'Processing':
        case 'Canceled':
        case 'Cancelled':
        case 'Void':
            textClass = 'status-text-dark-gray';
            break;
        case 'Pending Manager':
            textClass = 'status-text-warning disabled';
            break;
        case 'Pending Customer':
        case 'Pending':
        case 'In Repair':
        case 'Sourcing':
        case 'Repairing':
            textClass = 'status-text-warning';
            break;
        case 'Credit Note':
        case 'Open':
        case 'Purchased':
        case 'Reserved':
        case 'Unpaid':
        case 'Unprocessed':
            textClass = 'status-text-orange';
            break;
        case 'Pending':
        case 'Inspection':
        case 'Need Collection':
        case 'transit':
            textClass = 'status-text-dark-warning';
            break;
        case 'For Transit':
        case 'Shipped':
        case 'Submitted':
        case 'Paid':
        case 'Approved':
        case 'Accepted':
        case 'Verified':
        case 'Available':
        case 'Active':
        case 'Delivered':
            textClass = 'status-text-success';
        break;
        case 'Completed':
            textClass = 'status-text-dark-green';
        break;
        case 'For Credit Note':
        case 'Inspection Approval':
        case 'Collected':
        case 'Inbounded':
        case 'Received':
        case 'In Progress':
        case 'Dispatched':
            textClass = 'status-text-primary';
            break;
        case 'For Approval':
        case 'Unrepairable':
        case 'Incomplete':
        case 'Unverified':
        case 'Not Registered':
        case 'Inactive':
            textClass = 'status-text-danger';
            break;

        // case 'Concept':
        // 	textClass = 'status-text-light-orange';
        // 	break;
        case 'Customer':
        case 'Transit Company':
            textClass = 'status-text-title';
            break;
        default:
            textClass = '';
    }

    return (
        <span className={`${textClass}`}>
            {itemStatus === 'Credit Note' || itemStatus === 'Unprocessed'
                ? 'Open' : itemStatus}
        </span>
    );
};

export default StatusText;
